import {
    AsYouType,
    getCountryCallingCode,
    isValidPhoneNumber,
    parsePhoneNumberFromString
} from 'libphonenumber-js';
import { COUNTRIES } from '../auth/constants';

export const FALLBACK_PHONE_COUNTRY = COUNTRIES[0].code;
export const PHONE_NUMBER_ERROR = 'Enter a valid mobile number, including the country code.';

export function countryCallingCode(code) {
    try {
        return getCountryCallingCode(code);
    } catch {
        return '';
    }
}

export function resolvePhoneCountry(code) {
    if (code && countryCallingCode(code)) return code;
    return FALLBACK_PHONE_COUNTRY;
}

export function isPhoneNumberValid(value, { required = false } = {}) {
    const raw = (value ?? '').trim();
    if (!raw) return !required;
    return isValidPhoneNumber(raw);
}

export function isStoredPhoneUnparsed(value) {
    const raw = (value ?? '').trim();
    if (!raw) return false;
    return !parsePhoneNumberFromString(raw)?.country;
}

export function describeStoredPhone(value, defaultCountry) {
    const country = resolvePhoneCountry(defaultCountry);
    const raw = (value ?? '').trim();
    if (!raw) return { country, text: '' };

    const parsed = parsePhoneNumberFromString(raw);
    if (parsed?.country && countryCallingCode(parsed.country)) {
        return { country: parsed.country, text: parsed.formatNational() };
    }

    return { country, text: raw };
}

export function applyNationalInput(country, rawInput, previousText = '') {
    const trimmed = rawInput.trim();
    if (trimmed.startsWith('+')) {
        const parsed = parsePhoneNumberFromString(trimmed);
        if (parsed?.country && countryCallingCode(parsed.country)) {
            return {
                country: parsed.country,
                text: parsed.formatNational(),
                e164: parsed.number
            };
        }
    }

    let digits = rawInput.replace(/\D/g, '');
    const previousDigits = previousText.replace(/\D/g, '');
    if (previousText && rawInput.length < previousText.length && digits === previousDigits && digits) {
        digits = digits.slice(0, -1);
    }

    if (!digits) return { country, text: '', e164: '' };

    const typer = new AsYouType(country);
    const text = typer.input(digits);
    const e164 = typer.getNumber()?.number || `+${countryCallingCode(country)}${digits}`;
    return { country, text, e164 };
}
